<template>
  <div class="required_documents">
    <h4>필요 서류</h4>
    <p>
      모든 내용 입력 완료하신 후 필요 서류를 메일로 보내주셔야 합니다. <br />
      보내주신 서류를 검토하여 사업자 승인 처리를 해드리며, 승인 이후부터 포인트 전환 신청이 가능합니다.
    </p>
    <dl>
      <dt>필요 서류 :</dt>
      <dd><strong>사업자 등록증 사본 / 통장 사본 / 인감 증명서 / 계좌 확인서</strong></dd>
    </dl>
    <dl>
      <dt>보내실 email :</dt>
      <dd><a href="mailto:rewardpoint_biz@nexon.co.kr">rewardpoint_biz@nexon.co.kr</a></dd>
    </dl>
    <dl v-if="businessType === 3" style="margin-top: 10px">
      <dt>
        ※ 계좌 확인서는 <a href="/static/account-check.docx" download="계좌확인서.docx">다운로드</a> 받아 작성 후 인감
        날인하여 제출해주세요.<br />
      </dt>
      <dt>※ 인감증명서의 주민등록번호는 마스킹 처리 후 제출해주세요</dt>
    </dl>
    <dl v-else style="margin-top: 10px">
      <dt>
        ※ 계좌 확인서는 <a href="/static/account-check.docx" download="계좌확인서.docx">다운로드</a> 받아 작성 후 인감
        날인하여 제출해주세요.<br />
      </dt>
      <dt>※ 인감증명서의 주민등록번호는 마스킹 처리 후 제출해주세요.<br /></dt>
      <dt>
        ※ 인감이 없으신 개인사업자의 경우 계좌 확인서에 자필서명하시고, 자필 서명된 본인서명사실 확인서를 함께
        제출해주세요.<br />
      </dt>
      <dt>
        &nbsp;&nbsp;&nbsp;<a
          href="https://www.gov.kr/main?a=AA020InfoCappViewApp&HighCtgCD=A01008&CappBizCD=13110000047"
          target="_blank"
          >본인서명사실확인서 발급 안내</a
        >
      </dt>
    </dl>
  </div>
</template>

<script>
export default {
  props: {
    businessType: {
      type: Number,
      default: 0,
    },
  },
};
</script>
<style lang="scss"></style>
